import React from "react";
import {Badge} from "react-bootstrap";
import Tooltip from "../tooltip/Tooltip";

export function NewTabBadge(props) {


    return <Tooltip tooltip={props.tooltip}
                    placement={props.placement || "bottom"}

    >
        <Badge
            {...props}
            variant={props.variant || "primary"}
            onClick={() => window.open(props.newTabUrl, "_blank")}
            className={"cursor-pointer " + props.className}>
            {props.children}
        </Badge></Tooltip>
}